module.exports = __webpack_public_path__ + "media/footer/facebook-039975cc.svg";